import React, {useEffect, useState} from 'react'
import {Lang} from 'yougile-lang'

export const TextLoader: React.FC = () => {
  const [dots, setDots] = useState(0)
  useEffect(() => {
    const interval = setInterval(() => {
      setDots((dots + 1) % 8)
    }, 300)
    return () => clearInterval(interval)
  })
  return (
    <span>
      {Lang.msg.common.loading}
      {'.'.repeat(dots)}
    </span>
  )
}
